export {
  Primitive,
  //
  Root,
  //
  dispatchDiscreteCustomEvent,
} from './Primitive';
export type { PrimitivePropsWithRef } from './Primitive';
